"use client";

import { createContext, useContext, ReactNode } from "react";
import { CurrencyData } from "@/lib/currency";

const CurrencyContext = createContext<CurrencyData | undefined>(undefined);

export function CurrencyProvider({ 
  currency, 
  children 
}: { 
  currency: CurrencyData; 
  children: ReactNode; 
}) {
  return (
    <CurrencyContext.Provider value={currency}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    // Fallback to USD if not provided
    return {
      symbol: "$",
      code: "USD",
      name: "US Dollars",
      monthlyPrice: 12,
      annualPrice: 9.6,
    };
  }
  return context;
}
